/**
 * =========================================================
 * APP COMPONENT - Router และ Layout หลัก
 * =========================================================
 * อัลกอริทึม React Router:
 * 1. Routes = สแกน path จากบนลงล่าง
 * 2. Route แรกที่ match → render component นั้น
 * 3. ใช้ path pattern matching (wildcard, params)
 * =========================================================
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CourseListPage from './pages/CourseListPage';
import CourseDetailPage from './pages/CourseDetailPage';
import LessonPage from './pages/LessonPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import QuizPage from './pages/QuizPage';

// อัลกอริทึม Router Pattern Matching:
// 1. เปรียบเทียบ current URL กับ path pattern
// 2. ใช้ regex matching: /courses/:id → /courses/123 → match!
// 3. ดึง params: { id: '123' } ส่งให้ component
// 4. ถ้าไม่ match ทั้งหมด → ไป Route สุดท้าย (404)

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* Public Routes */}
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />
        <Route path="courses" element={<CourseListPage />} />
        <Route path="courses/:id" element={<CourseDetailPage />} />
        
        {/* Protected Routes (ต้อง login) */}
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="courses/:id/learn" element={<LessonPage />} />
        <Route path="courses/:id/quiz/:quizId" element={<QuizPage />} />
        
        {/* 404 */}
        <Route path="*" element={<div className="p-8 text-center">404 - Page Not Found</div>} />
      </Route>
    </Routes>
  );
}

export default App;
